import {
    Backdrop,
    Box,
    Button,
    Fade,
    Modal,
    Stack,
    Typography,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../../hooks/redux'
import { removeAccount } from '../../redux/slices/accountSlice'
import { logout } from '../../redux/slices/authSlice'

interface IProps {
    handleClose: () => void
    open: boolean
}

export default function ConfirmLogout(props: IProps): JSX.Element {
    const { handleClose, open } = props

    // Utils
    const navigate = useNavigate()
    // Redux
    const dispatch = useAppDispatch()

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
            sx={{ zIndex: 10000 }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '30%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90%',
                        bgcolor: 'background.paper',
                        borderRadius: 0.8,
                        p: 4,
                    }}
                >
                    <Typography
                        id="transition-modal-title"
                        variant="h6"
                        component="h2"
                    >
                        آیا از گواهی خود پشتیبان گرفته‌اید؟
                    </Typography>
                    <Typography
                        id="transition-modal-description"
                        sx={{
                            mt: 2,
                            color: (theme) => theme.palette.warning.main,
                        }}
                    >
                        در صورت عدم پشتیبان گیری باید مجددا گواهی دریافت کنید
                    </Typography>
                    <Stack
                        direction="row"
                        mt={3}
                        spacing={3}
                        justifyContent="space-between"
                    >
                        <Button
                            variant="contained"
                            color="error"
                            fullWidth
                            onClick={() => {
                                dispatch(removeAccount())
                                dispatch(logout())
                            }}
                        >
                            بله گرفتم!
                        </Button>
                        <Button
                            variant="contained"
                            color="warning"
                            fullWidth
                            onClick={() => {
                                handleClose()
                                navigate('/account/backup')
                            }}
                        >
                            خیر! برو به پشتیبان‌گیری
                        </Button>
                    </Stack>
                </Box>
            </Fade>
        </Modal>
    )
}
